<template>
  <div>
    <div :style="{height:topHeight}">
      <div class="top-box" :style="{'height':topHeight,'background-color':colorTopBg}"></div>
    </div>
    <div class="dr-home-bar" :style="{'height':'54px','background-color':colorTopBg}">
      <dr-row class="dr-home-bar-fixed" :style="{'top':topHeight,'height':'54px','background-color':colorTopBg}" justifyContent="space-between" alignItems="center">
        <van-icon :name="colorTopBg == '#000000'?'static/imgs/back.png':'static/imgs/back_black.png'" size="20" @click="backUp" />
        <dr-row>
          <slot></slot>
        </dr-row>
      </dr-row>
    </div>
    <div style="height:54px"></div>
  </div>
</template>

<script>
export default {
  props:{
    bgColor:{
      type:String,
      default:'#ffffff'
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.colorTopBg = val.meta.color
      },
      // 深度观察监听
      immediate: true
    },
    bgColor:{
      handler: function (val, oldVal) {
        console.log(val);
        this.colorTopBg = val
      },
      // 深度观察监听
      immediate: true
    },
  },
  data () {
    return {
      colorTopBg: "",
    }
  },
  mounted () {
    
  },
  methods: {
    backUp () {
      this.$router.back()
    },
  }
}
</script>

<style scoped>
.dr-home-bar{
  height: 54px;
}
.dr-home-bar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 54px;
  background-color: #ffffff;
  padding: 0 15px 0 5px;
  box-sizing: border-box;
  z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/components/drTitelBar/index2.vue